import AuthPages from 'components/AuthPages/AuthPages';
import FormRegister from 'components/FormRegister/FormRegister';

const Register = () => {
  return (
    <>
      <AuthPages>
        <FormRegister />
      </AuthPages>
    </>
  );
};

export default Register;
